export default function PHP_filter_has_var() {
  return (
    <div>
      <h1>PHP_filter_has_var</h1>
    </div>
  );
}
